module.exports = __webpack_public_path__ + "static/livics-a0775a92f33eb4f9fce5a8710c30d27f.png";